let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("h0qHX"), load("hKZXM"), load("kpR8r")]).then(() => parcelRequire('hQs9f'));